/**
 * This index is used only in the merchant and outlet settings(because there is a route),
 * route-segment didn't work when tries to render the component because there is some data ...
 * that is passed to the component.
 * When it's need to use the component/directive it won't pass here, for instance merchant creation and outlet creation
 * @param merchantInfoData
 * @param integrationConstant
 * @param $location
 * @param outletData
 * @param outletsFeaturesInfo
 * @param listPosPartners
 */
function indexIntegrationController(merchantInfoData, integrationConstant, $location, outletData,
                                    outletsFeaturesInfo, listPosPartners) {
    const vm = this;
    const LOCATION = integrationConstant.LOCATION;
    const hashPath = $location.path();

    const currentLocation =
        Object.keys(LOCATION)
            .map(item => LOCATION[item].value)
            .filter(item => hashPath.indexOf(item) !== -1)[0];

    const mapCondition = {
        '/merchant/settings/integration': {
            data: merchantInfoData,
            location: LOCATION.merchantAdmin.label,
            outletsSummaryData: outletsFeaturesInfo
        },
        '/outlet/settings/integration': {
            data: outletData,
            parentData: merchantInfoData,
            location: LOCATION.outletAdmin.label
        }
    };

    vm.posPartners = listPosPartners;

    vm.placement = mapCondition[currentLocation];
}
angular.module('qkr.integration.settings')
    .controller('IndexIntegrationController', indexIntegrationController);





// WEBPACK FOOTER //
// ./src/integration-settings/controllers/index.integration.controller.js